module.exports = __webpack_public_path__ + "img/yellowstar.08d60b04.svg";